import { LayerGeomtypes } from 'src/app/model/sl-layer';
import { AttributeInfo } from './../../../types/@types/sl-v-types.d';
import { SlWapiService } from './../sl-wapi.service';
import { AnyHandler, AttributeRequirement } from 'src/app/types/@types/sl-v-types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { replace } from 'lodash';
import { ArcgisServiceListItem } from 'src/app/mapps/dmi-pages/data/arcgis/arcgis-config/arcgis-config.component';
export type DBDate = string;
export type ArcGIS_LayerURL = string;
export type FieldWhiteList = '*' | Array<string>;
export type ArcGIS_Creds = {
  method: 'token' | 'basic' | 'key',
  username?: string,
  password?: string
  token?: string,
  key?: string
}

export type RemoteLayerTiming = {
  refresh_interval: 'weekly' | 'monthly' | 'manual',
  refresh_day?: number,
  next_refresh?: DBDate,

}
export type ArcGIS_LayerUpsertParams = {
  name: string,
  description: string,
  field_whitelist: FieldWhiteList,
  src: ArcGIS_LayerURL,
  creds?: ArcGIS_Creds,
  max_records?: number,
  page_size?: number,
  srsWkId?: number,
  srs?: string,
  layerid?: number
} & RemoteLayerTiming
export type ArcGIS_LayerLookupInfo = {
  name: string;
  id: number;
}
export type ESRITypeLookup = {
  [key: string]: AttributeRequirement;
}
export type ArcGIS_URL_Info = {
  folder: string;
  service: ArcgisServiceListItem;
  layer: string; // integer string
}
export type ArcGIS_LayerLookup = Array<ArcGIS_LayerLookupInfo>;

export type ArcGISServiceURLParts = {
  folder: string | null;
  serviceName: string | null;
  serviceType: string | null;
  additionalParams: string[];
  service: { name: string, type: string }
}
@Injectable({
  providedIn: 'root'
})
export class ArcgisService {
  public layers: Array<any>;
  constructor(private wapi: SlWapiService) { }

  public static readonly esriTypeLookup = {
    esriFieldTypeDouble: 'float',
    esriFieldTypeString: 'text',
    esriFieldTypeDate: 'date',
    esriFieldTypeInteger: 'integer',
    esriFieldTypeGeometry: 'geometry',
    esriFieldTypeSingle: 'integer',
    esriFieldTypeSmallInteger: 'integer'
  }

  public static readonly esriGeometryLookup = {
    esriGeometryPolygon: LayerGeomtypes.Polygon,
    esriGeometryPoint: LayerGeomtypes.Point,
    esriGeometryMultiPoint: LayerGeomtypes.Point,
    esriGeometryEnvelope: LayerGeomtypes.Polygon,// 'envelope'
    esriGeometryPolyLine: LayerGeomtypes.Line
  }

  GetInfo(url: string, handler: AnyHandler) {

    if (url.indexOf('?') === -1) {
      url += '?f=json';
    }
    this.wapi.Post('tools/proxy', { url: (url) }, true).then((response) => {
      if (!!response) {
        handler(response);
      }
    })
  }
  GetServicesRoot(url: string) {
    const urlParts = url.split('/');
    let rootURL = '';
    for (const part of urlParts) {
      rootURL += part + '/';
      if (part === 'services') {
        if (rootURL.substring(rootURL.length - 14) == 'rest/services/') {
          break;
        }
      }
    }
    return rootURL;
  }
  GetFolders(url: string, handler: AnyHandler) {
    const rootURL = this.GetServicesRoot(url);
    console.log(rootURL);
    this.GetInfo(rootURL, handler);
  }
  GetFolder(url: string, folder: string, handler: AnyHandler) {
    const rootURL = this.GetServicesRoot(url);
    this.GetInfo(rootURL + folder + '/', handler);
  }

  GetFolderPath(url: string, selectedFolder: string = ''): string {
    const urlInfo = this.ParseServiceURL(url);
    const rootURL = this.GetServicesRoot(url);
    let folder = urlInfo.folder ? urlInfo.folder : selectedFolder;
    if (!!folder && folder.charAt(folder.length - 1) !== '/') folder += '/';
    let path = rootURL + folder;

    return path;
  }
  GetServicePath(url: string, selectedFolder: string = '', service: ArcgisServiceListItem) {
    const basePath = this.GetFolderPath(url, selectedFolder);
    if (service.name === '' && service.type !== '') {
      return basePath + service.type + '/';
    } else {
      return basePath + service.name + '/' + service.type + '/';
    }


  }
  GetService(url: string, selectedFolder: string, service: ArcgisServiceListItem, handler: AnyHandler) {
    this.GetInfo(this.GetServicePath(url, selectedFolder, service), handler);
  }
  GetLayerPath(url: string, selectedFolder:string = '',service: ArcgisServiceListItem, layerId: number | string): string {
    const baseURL = this.GetServicePath(url, selectedFolder, service);
    return baseURL + '' + layerId + '/';
  }
  ParseServiceURL(url: string): ArcGISServiceURLParts {
    const serviceTypes = [
      "MapServer",
      "FeatureServer",
      "ImageServer",
      "GPServer",
      "GeometryServer",
      "NAServer",
      "GeocodeServer",
      "SceneServer",
      "StreamServer",
      "VectorTileServer",
      "UtilityNetworkServer",
      "AnalysisServer"
    ];

    const rootSvc = this.GetServicesRoot(url);;

    const rootIndex = url.indexOf(rootSvc);

    // Extract the path after '/arcgis/rest/services/'
    const path = url.substring(rootIndex + rootSvc.length).split('/').filter(Boolean);

    // Find the service type in the path
    const serviceTypeIndex = path.findIndex(part => serviceTypes.includes(part));

    let folder = serviceTypeIndex > 1 ? path.slice(0, serviceTypeIndex - 1).join('/') : null;

    if (serviceTypeIndex === -1) {
      if (path.length === 1) folder = path.shift();
    }

    // Extract the folder, service name, and additional parameters
    const serviceName = serviceTypeIndex > 0 ? path[serviceTypeIndex - 1] : null;
    const serviceType = path[serviceTypeIndex];
    const additionalParams = path.slice(serviceTypeIndex + 1);
    folder = folder ?? '';
    return {
      folder,
      serviceName,
      serviceType,
      additionalParams,
      service: { name: serviceName, type: serviceType }
    };
  }



  GetDocumentLayers(document: any): ArcGIS_LayerLookup {
    const layers = [];
    if (document.layers) {
      for (const layer of document.layers as Array<any>) {
        layers.push({ name: layer.name, id: layer.id });
      }
    }
    return layers as ArcGIS_LayerLookup;
  }
  QueryLayer(layerURL: string, query?: any, asCount: boolean = false, handler?: AnyHandler) {
    if (asCount) {
      const countRequest = this.wapi.Post('tools/proxy', { url: layerURL + "query?where=1=1&returnCountOnly=true&f=json" }, true);
      countRequest.then((response) => {
        if (handler) handler(response);
        countRequest.abort();
      });
      return;
    }
    let url = layerURL + "query?";
    if (!query) query = { where: '1=1' };
    let prefix = '';
    for (const key in query) {
      url += prefix + key + '=' + query[key];
      prefix = '&';
    }
    url += (query?.returnGeometry === true) ? '&f=geojson' : '&f=json';
    const request = this.wapi.Post('tools/proxy', { url: url }, true);
    request.then((response) => {
      if (handler) handler(response);
      request.abort();
    });

  }
  GetLayer(url: string, handler: AnyHandler) {
    url += '?f=json'
    const request = this.wapi.Post('tools/proxy', { url: (url) }, true);
    request.then((response) => {
      handler(response);
      request.abort();
    });
  }
  LayerFieldsToAttributes(layerInfo): Array<AttributeInfo> {
    if (!layerInfo.fields) return [];
    const fields = layerInfo.fields;
    const atts: Array<AttributeInfo> = [];
    for (const field of fields) {
      const attribute: AttributeInfo = {
        type: ArcgisService.esriTypeLookup[field.type],
        display: (!!field.alias) ? field.alias : field.name,
        name: field.name,
        requires: ArcgisService.esriTypeLookup[field.type],
        searchable: true,
        visible: true
      }
      switch (field.type) {
        case 'esriFieldTypeOid':
          attribute.type = 'bigint';
          attribute.name = 'gid';
          attribute.requires = 'numeric';
          break;
        case 'esriFieldTypeGeometry':
          attribute.type = 'geometry';
          attribute.name = 'the_geom';
          attribute.requires = 'geometry'
          break;
        default:
      }
      atts.push(attribute);
    }
    return atts;
  }
  GetSRS(wkid: string | number, handler: AnyHandler) {
    this.wapi.Post('layers/projections/get-by-code/', { auth: 'EPSG', id: '' + wkid, with: 'sr' }, true).then((response) => {
      if (response.response.results.length === 0) handler(null);
      handler(response.response.results[0]);
    })
  }
  GetPGType(field: any) {
    switch (field.type) {
      case 'esriFieldTypeString':       // Common for text fields
        return 'text';
      case 'esriFieldTypeInteger':      // Common for numeric fields
        return 'integer';
      case 'esriFieldTypeDouble':       // Common for precise numeric fields
        return 'float';
      case 'esriFieldTypeDate':         // Common for date/time fields
        return 'timestamp';
      case 'esriFieldTypeOID':          // Used as primary key
        return 'bigint';
      case 'esriFieldTypeSmallInteger': // Less common numeric field
        return 'integer';
      case 'esriFieldTypeGeometry':     // Used for spatial data
        return 'geometry';
      case 'esriFieldTypeSingle':       // Rare, less precise than Double
        return 'real';
      case 'esriFieldTypeGlobalID':     // Globally unique IDs
      case 'esriFieldTypeGUID':
        return 'uuid';
      case 'esriFieldTypeBlob':         // Binary data like images
        return 'bytea';
      case 'esriFieldTypeRaster':       // For raster data
        return 'raster';
      case 'esriFieldTypeXML':          // For XML data storage
        return 'xml';
      default:
        return 'text';

    }
  }

  UpsertLayer(layerURL: string, params: ArcGIS_LayerUpsertParams) {
    return this.wapi.Post('layers/remote/arcgis_layer/upsert', params, true);
  }




}
